// extracted by mini-css-extract-plugin
export default {"totalPrice":"_2lAxP","totalPriceRow":"Sq90s"};